import { gql } from 'src/__generated__';

const EXECUTE_REPORT = gql(`#graphql
  mutation ExecuteReport($input: ExecuteReportInput!) {
    executeReport(input: $input)
  }
`);

export default EXECUTE_REPORT;
